import * as React from 'react';
import Grid from '@mui/material/Grid';
import { Outlet } from 'react-router-dom';
import { Header } from '../Header/Header';
import { Box } from '@mui/material';

export default function MyLayout():JSX.Element {

  return (
    <Box sx={{ flexGrow: 1 }}>
    <Grid container spacing={0}>
        <Grid item xs={12}>
        <Header />
        </Grid>
      </Grid>
      <Grid container spacing={{ xs: 1, sm: 2, md: 1, lg: 2 }}>
            <Grid item xs={12}>
            <Outlet></Outlet>
            </Grid>
    </Grid>
    </Box>

  );
};